<div class="flex h-full flex-col bg-background lg:flex-row">
  <section
    class="flex flex-col bg-linear-to-br from-brand-studio-dark to-brand-studio px-5 pb-9 text-white sm:px-8 sm:pb-16 lg:min-h-full lg:w-1/2 lg:px-12">
    <header class="flex h-14 shrink-0 items-center justify-between gap-3 sm:h-16">
      <div class="flex min-w-0 items-center gap-2">
        <img src="/assets/logos/official/SHOUT_icon_white.svg" alt="" class="h-7 w-auto" />
        <p class="m-0 text-2xl font-black leading-none tracking-tight">SHOUT</p>
        <p class="m-0 text-xl font-bold leading-none">Studio</p>
      </div>
      <a routerLink="/login" class="shrink-0 text-lg font-bold text-white hover:text-white/80">Sign in</a>
    </header>

    <div class="flex flex-1 flex-col justify-center gap-3 pt-2 sm:gap-4 sm:pt-10">
      <h1
        class="use-grotesque m-0 origin-bottom-left -skew-x-6 text-5xl font-extrabold leading-none tracking-tight text-balance sm:text-6xl lg:text-8xl">
        Creator Campaigns In Minutes.
      </h1>
      <p class="m-0 text-xl font-semibold leading-tight">
        <span class="whitespace-nowrap">AI briefs, instant creator matching, </span><wbr><span class="whitespace-nowrap">100% brand safe.</span>
      </p>
      <div class="flex flex-nowrap items-center gap-4 overflow-hidden pt-1">
        <img src="/assets/logos/cloud/adobe_dark.svg" alt="Adobe" class="h-6 w-auto shrink-0 brightness-0 invert" />
        <img src="/assets/logos/cloud/byd_dark.svg" alt="BYD" class="h-3 w-auto shrink-0 brightness-0 invert" />
        <img src="/assets/logos/cloud/golin_dark.svg" alt="GOLIN" class="h-4 w-auto shrink-0 brightness-0 invert" />
        <img src="/assets/logos/cloud/pizzahut_dark.svg" alt="Pizza Hut"
          class="h-4 w-auto shrink-0 brightness-0 invert" />
        <img src="/assets/logos/cloud/monday_dark.svg" alt="monday.com"
          class="h-3 w-auto shrink-0 brightness-0 invert" />
      </div>
    </div>
  </section>

  <section
    class="relative -mt-5 flex flex-1 flex-col rounded-t-3xl bg-background p-5 sm:px-8 sm:pt-10 sm:pb-14 lg:mt-0 lg:min-h-full lg:w-1/2 lg:justify-center lg:rounded-none lg:px-12 lg:py-16">
    <div class="mx-auto flex w-full max-w-md flex-col gap-3">
      <!-- <p class="m-0 text-2xl font-bold leading-none">I'm a…</p> -->

      <div class="flex flex-col gap-3">
        <p class="m-0 text-sm font-bold uppercase tracking-widest text-primary">Choose your path</p>
        <h1 class="use-grotesque m-0 text-4xl font-bold leading-none tracking-tight text-balance sm:text-5xl">
          What describes you <span class="text-primary">best?</span>
        </h1>
        <!-- <p class="m-0 text-md font-semibold leading-snug text-zinc-600">Pick your route and we'll only show you what's
          relevant.</p> -->
      </div>

      <div class="flex flex-col gap-2">
        @for (option of options(); track option.id) {
        <button type="button"
          class="flex w-full items-center gap-4 rounded-xl border border-border bg-card p-2 text-left transition hover:border-primary hover:bg-primary/5 active:scale-[0.98] md:p-4"
          (click)="choose(option.id)">
          <span class="flex size-12 shrink-0 items-center justify-center rounded-lg text-white" [class]="option.tile"
            aria-hidden="true">
            @switch (option.icon) {
            @case ('building') {
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="1.8" class="size-6">
              <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18" />
              <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2" />
              <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2" />
              <path d="M10 6h4" />
              <path d="M10 10h4" />
              <path d="M10 14h4" />
              <path d="M10 18h4" />
            </svg>
            }
            @case ('layers') {
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="1.8" class="size-6">
              <path d="m12 2 9 5-9 5-9-5 9-5Z" />
              <path d="m3 12 9 5 9-5" />
              <path d="m3 17 9 5 9-5" />
            </svg>
            }
            @case ('user') {
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="1.8" class="size-6">
              <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
              <circle cx="12" cy="7" r="4" />
            </svg>
            }
            }
          </span>
          <span class="min-w-0 flex-1">
            <span class="block text-xl font-bold text-primary">{{ option.title }}</span>
            <span class="mt-1 block text-sm font-medium text-primary">{{ option.description }}</span>
            <!-- <span class="mt-1 block text-sm font-bold text-primary">{{ option.price }}</span> -->
          </span>
          <span class="flex size-9 shrink-0 items-center justify-center rounded-full bg-foreground text-background"
            aria-hidden="true">→</span>
        </button>
        }
      </div>

      <p class="m-0 text-center text-base font-semibold text-muted-foreground">
        Already have an account?
        <a routerLink="/login" class="font-bold text-primary hover:text-primary/80">Sign in</a>
      </p>
    </div>
  </section>
</div>